module.exports = __webpack_public_path__ + "static/Stateofimpact_43-e1224144355bb509e33eebe6556578b0.jpg";